import { resolveComponent as l, openBlock as t, createElementBlock as c, createElementVNode as r, createBlock as i, createCommentVNode as a, toDisplayString as u } from "vue";
import { _ } from "./_plugin-vue_export-helper-dad06003.js";
import { A as g } from "./AlertCircleIcon-61966fff.js";
import { C as y } from "./CheckCircleIcon-17128890.js";
import { A as C } from "./AlertTriangleIcon-d613f6a8.js";
import { B as k } from "./ButtonCloseSmXs-a1e8d8e7.js";
const T = {
  components: {
    AlertCircleIcon: g,
    CheckCircleIcon: y,
    ButtonCloseSmXs: k,
    AlertTriangleIcon: C
  },
  props: {
    type: {
      type: String,
      default: "default"
    },
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    noClose: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close"],
  data() {
    return {
      interval: null,
      currentTime: 3,
      paused: !1
    };
  },
  mounted() {
    this.startTimer();
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    startTimer() {
      this.noClose || (this.interval = setInterval(() => {
        this.paused || (this.currentTime--, this.currentTime <= 0 && (clearInterval(this.interval), this.$emit("close")));
      }, 1e3));
    },
    pauseTimer() {
      this.paused = !0;
    },
    resumeTimer() {
      this.paused = !1;
    }
  }
}, v = { class: "flex flex-row items-center sm:items-start space-x-3 sm:space-x-0 sm:flex-col sm:space-y-4 mb-2" }, b = {
  key: 3,
  class: "ct-text-2 text-xs sm:text-base font-medium"
}, w = ["innerHTML"], I = { class: "absolute top-2 sm:top-4 right-2 sm:right-4" }, A = {
  key: 0,
  class: "p-2"
}, B = { class: "w-5 h-5 rounded-full border border-gray-400 dark:border-neutral-500 bg-gray-50 dark:bg-neutral-800 flex items-center justify-center" }, S = { class: "text-gray-400 dark:text-neutral-500 text-xs font-bold" };
function M(d, s, e, X, m, n) {
  const f = l("AlertCircleIcon"), h = l("CheckCircleIcon"), p = l("AlertTriangleIcon"), x = l("ButtonCloseSmXs");
  return t(), c("div", {
    class: "relative w-full sm:rounded-lg border-b sm:border ct-border-1 ct-bg-1--alt p-5 sm:p-6 shadow-xl",
    onMouseenter: s[1] || (s[1] = (...o) => n.pauseTimer && n.pauseTimer(...o)),
    onMouseleave: s[2] || (s[2] = (...o) => n.resumeTimer && n.resumeTimer(...o))
  }, [
    r("div", v, [
      e.type === "error" ? (t(), i(f, {
        key: 0,
        class: "h-4.5 sm:h-6 w-4.5 sm:w-6 text-error-600 dark:text-error-500",
        "aria-hidden": "true"
      })) : a("", !0),
      e.type === "success" ? (t(), i(h, {
        key: 1,
        class: "h-4.5 sm:h-6 w-4.5 sm:w-6 text-success-600 dark:text-success-500",
        "aria-hidden": "true"
      })) : a("", !0),
      e.type === "warning" ? (t(), i(p, {
        key: 2,
        class: "h-4.5 sm:h-6 w-4.5 sm:w-6 text-warning-400 dark:text-warning-400",
        "aria-hidden": "true"
      })) : a("", !0),
      e.title ? (t(), c("h3", b, u(e.title), 1)) : a("", !0)
    ]),
    r("p", {
      class: "ct-text-3 text-xs sm:text-sm",
      innerHTML: e.message
    }, null, 8, w),
    r("div", I, [
      !e.noClose && !m.paused ? (t(), c("div", A, [
        r("div", B, [
          r("p", S, u(m.currentTime), 1)
        ])
      ])) : (t(), i(x, {
        key: 1,
        onClick: s[0] || (s[0] = (o) => d.$emit("close"))
      }))
    ])
  ], 32);
}
const D = /* @__PURE__ */ _(T, [["render", M]]);
export {
  D as A
};
